// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-dynamic[data-v-6ba28cdc]{display:flex;flex-wrap:wrap}.search-dynamic .dynamic-row[data-v-6ba28cdc]{display:flex;align-items:center;margin-bottom:.5rem}.search-dynamic .w120[data-v-6ba28cdc]{min-width:120px}.search-dynamic .w60[data-v-6ba28cdc]{min-width:60px}.search-dynamic .w70[data-v-6ba28cdc]{min-width:70px}.search-dynamic .w200[data-v-6ba28cdc]{min-width:200px}", ""]);
// Exports
module.exports = exports;
